<template lang="pug">
#tagSetting
  .title 标签管理
  .nav
    el-button(type="primary" size="small" plain @click="addTag") 添加标签
  .content
    el-table(ref="multipleTable" highlight-current-row size="small" border height="100%" :data="tableData")
      //- el-table-column(label="移动" width="50" align="center")
        i.iconfont.icon-drag.drag-option
      el-table-column(label="标签id" align="center" prop="tagId")
      el-table-column(label="标签名称" align="center" prop="tagName" v-slot="{row}")
        el-link(type="primary" @click="editTag(row)")
          span(class="tabLinkSpan" :title='row.tagName') {{ row.tagName }}
      el-table-column(label="状态" align="center" prop="status" v-slot="{row}")
        span {{row.status===0?"启用":"禁用"}}
      el-table-column(label="操作" align="center" prop="status" v-slot="{row}")
        el-button(type="primary" size="mini" plain @click="editTag(row)") 修改
        //- el-button(type="primary" size="mini" plain v-if="row.status===0" @click.stop="disableTag(row)") 禁用
        el-button(type="primary" size="mini" plain v-if="row.status===1" @click.stop="enableTag(row)") 启用
        el-button(type="danger" size="mini" plain @click.stop="deleteTag(row)") 删除
  el-dialog(v-dialogDrag, :title="tagTitle", :visible.sync="tagDialog", width="400px", :before-close="handleClose")
    el-form(ref="form", :model="form", label-width="100px", size="small", label-position="top", :rules="rules")
      //- el-form-item(label="标签状态", prop="status")
      //-   el-radio(v-model="form.status" :label="0" ) 启用
      //-   el-radio(v-model="form.status" :label="1" ) 禁用
      el-form-item(label="标签名称", prop="tagName")
        el-input(v-model="form.tagName", clearable maxlength="30" show-word-limit)
    div(slot="footer")
      el-button(@click="handleClose", size="small") 取 消
      el-button(type="primary", @click="onSubmit", size="small") 确 定
</template>

<script>
import tagService from "@/CommonDP/service/tag-service";
import { mapState } from "vuex";
import Sortable from 'sortablejs';

export default {
  name: "TagManagement",
  data () {
    return {
      tableData: [],
      tagDialog: false,
      rules: {
        tagName: [{ required: true, message: '标签名称', trigger: 'blur' }]
      },
      tagTitle: "",
      form: {
        tagId: "",
        status: 0,
        tagName: ""
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted () {
    this.getSysTagList();
    this.pullSort();
  },
  methods: {
    async getSysTagList() {
      const res = await tagService.sysTagList(this.enterpriseId);
      this.tableData = res.data || [];
    },
    // 表格拖动排序方法
    pullSort() {
      // 通过ref获取Dom节点
      const el = this.$refs.multipleTable.$el.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      this.sortable = Sortable.create(el, {
        animation: 200, // 拖拽动画(毫秒)
        handle: ".drag-option",
        setData: function (dataTransfer) {
          dataTransfer.setData("Text", "");
        },
        // 结束拖拽
        onEnd: (e) => {
          // e.oldIndex为拖动一行原来的位置；e.newIndex为拖动后新的位置
          const oldRow = this.tableData[e.oldIndex]; // 移动元素集合
          const newRow = this.tableData[e.newIndex]; // 新的元素集合
          console.log(oldRow, "移动元素集合");
          console.log(newRow, "新的元素集合");
          // 调用接口传参即可
        }
      });
    },
    // 添加标签
    addTag() {
      this.tagTitle = "添加标签";
      this.tagDialog = true;
      this.form.tagId = "";
      this.form.tagName = "";
    },
    async onSubmit() {
      await this.$refs.form.validate();
      const { tagName } = this.form;
      if (this.tagTitle === "添加标签") {
        const params = {
          enterpriseId: this.enterpriseId,
          ...this.form,
          tagName: tagName.trim()
        };
        try {
          await tagService.sysTagAdd(params);
          this.$success("添加成功!");
          this.getSysTagList();
          this.tagDialog = false;
        } catch (error) {
          console.log(error);
        }
      } else if (this.tagTitle === "修改标签") {
        const params = {
          enterpriseId: this.enterpriseId,
          ...this.form,
          tagName: tagName.trim()
        };
        try {
          await tagService.sysTagUpdate(params);
          this.$success("修改成功!");
          this.getSysTagList();
          this.tagDialog = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
    editTag(row) {
      this.tagTitle = "修改标签";
      this.tagDialog = true;
      this.form.tagId = row.tagId;
      this.form.tagName = row.tagName;
    },
    async deleteTag(row) {
      await this.$confirm("是否删除该标签?", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning"
      });
      try {
        await tagService.sysTagDelete(row.tagId);
        this.$success("删除成功!");
        this.getSysTagList();
      } catch (error) {
        console.log(error);
      }
    },
    // 禁用标签
    async disableTag(row) {
      try {
        await tagService.sysTagdisable(row.tagId);
        this.getSysTagList();
      } catch (error) {
        console.log(error);
      }
    },
    // 启用标签
    async enableTag(row) {
      try {
        await tagService.sysTagEnable(row.tagId);
        this.getSysTagList();
      } catch (error) {
        console.log(error);
      }
    },
    handleClose() {
      this.tagDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
#tagSetting{
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .title{
    font-weight: 900;
    font-size: 16px;
    color: var(--theme-color);
    padding: var(--middle-space) var(--big-space);
    border-bottom: 1px solid #ebefff;
  }
  .nav{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: var(--middle-space) var(--big-space);
  }
  .content{
    height: 1px;
    flex-grow: 1;
    padding: 0 var(--big-space) var(--middle-space);
  }
  .drag-option {
    cursor: pointer;
  }
}
</style>
